import {useNavigate} from 'react-router-dom';

import {GuidesEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';

import {OptionsDrawerItem} from '../types';
import {translations} from 'presentation/translations-new';
import {usePpoNetworkStore} from 'presentation/modules/guide/shared/store/guideStore/usePpoNetworkStore';
import {ppoNetworkTypeEnum} from 'presentation/modules/guide/shared/store/guideStore/types';

const {consultHealthNetwork, consultOdontoNetwork} = translations['pt-br'].privateFlow.services;

function useAccreditedNetworkItems() {
	const navigate = useNavigate();
	const closeOptionsDrawer = useOpenOptionsDrawerStore(state => state.closeOptionsDrawer);
	const setPpoNetworkType = usePpoNetworkStore(state => state.setPpoNetworkType);
	const {healthOnly, odontoOnly, isResponsibleWithoutBenefits, isB2BAccess} =
		useAccountInformation();
	const {isValid} = useContractStatus();

	const showNetworkProviderHealth =
		isValid && !isB2BAccess && !isResponsibleWithoutBenefits && !odontoOnly;

	const showNetworkProviderOdonto = isValid && !isResponsibleWithoutBenefits && !healthOnly;

	const handleClick = (route: string) => {
		closeOptionsDrawer();
		navigate(route);
	};

	const ALL_ITEMS: (OptionsDrawerItem & {show: boolean})[] = [
		{
			label: consultHealthNetwork,
			icon: 'stethoscope',
			onClick: () => {
				setPpoNetworkType(ppoNetworkTypeEnum.ACCREDITED_NETWORK);
				handleClick(GuidesEnum.SERVICE_NETWORK_HEALTH);
			},
			show: showNetworkProviderHealth,
		},
		{
			label: consultOdontoNetwork,
			icon: 'tooth-outline',
			onClick: () => handleClick(GuidesEnum.SERVICE_NETWORK_ODONTO),
			show: showNetworkProviderOdonto,
		},
	];

	const items: OptionsDrawerItem[] = ALL_ITEMS.filter(item => item.show).map(
		({show: _, ...item}) => item,
	);

	return {items};
}

export {useAccreditedNetworkItems};
